module.exports = __webpack_public_path__ + "static/img/news2.44f7a18.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/news2.png
// module id = 6mVK
// module chunks = 7